import { useMemo } from 'react';

import { useAtomValue } from 'jotai';

import { FloorGraph } from '@blocks';
import { useRelations, useLayoutCustomizations, useUiGraph } from '@queries';
import { layoutAtom } from '@store';

export const Graph = ({ nodeId }: { nodeId: string }) => {
    const { data: modules } = useUiGraph();
    const { data: relations } = useRelations();

    const activeLayout = useAtomValue(layoutAtom);
    const graphNode = useMemo(() => modules?.find((node) => node.id === nodeId), [modules, nodeId]);
    const { data: graphLines } = useLayoutCustomizations(activeLayout?.id ?? -1, ['graph_line']);

    const availableGraphLines = useMemo(
        () =>
            relations
                ?.filter((relation) => relation.parentUiNodeId === nodeId)
                .map((relation) => relation.childUiNodeId) || [],
        [nodeId, relations],
    );

    const showGraphLines = useMemo(
        () =>
            graphLines
                ?.filter(
                    (graphLine) =>
                        graphLine.parentUiNodeId === graphNode?.id && graphLine.showChildOn?.includes('floor'),
                )
                .map((d) => d.childUiNodeId),
        [graphLines, graphNode?.id],
    );

    const omitGraphLines = useMemo(
        () => (showGraphLines?.length ? availableGraphLines.filter((lineId) => !showGraphLines.includes(lineId)) : []),
        [availableGraphLines, showGraphLines],
    );

    return <FloorGraph nodeId={nodeId} omitNodes={omitGraphLines} />;
};
